module.exports = __webpack_public_path__ + "staticcomp/img/content_5.88251b9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/3/10/content_5.jpg
// module id = 7/dB
// module chunks = 39